import './About.css';

function About() {
    return (
      <div className="About hide-scrollbar">
        <h1>혁／CATADIOPTRIC</h1>
        <p>I make stuff.</p>
        <br />

        <h2>I do</h2>
        <ul>
          <li>Art／Illustration</li>
          <li>Graphic Design</li>
          <li>Motion Graphic／Animation</li>
          <li>Comic／Graphic Novel</li>
          <li>Unity Development</li>
          <li>Web Development</li>
          <li>Music Producing</li>
        </ul>
        <br />

        <h2>Language</h2>
        <p>Korean／English／Japanese</p>
      </div>
    );
  }
  
  export default About;
  